import { LEAD_STATUS } from '@/constants';

export function hasValidRegistration(details) {
  if (!details) return true;

  const code = details.registration_status_code;
  if (!code) return true;

  const validCodes = [LEAD_STATUS.ACTIVE];
  return validCodes.includes(code);
}
